export default () => ({
  vaccines: null,
  vaccineList: null,
  agencyDeployments: {},
  agentDeployments: {},
  allOses: [],
  allTypes: [],
  allCategories: [],
  editingVaccine: null,
  dqlFields: {},
  loading: false,
  page: 0,
  sortBy: "name",
  orderBy: "asc",
  search: "",
});
